import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { QuotationEntity } from "domain/entity/QuotationSetting/QuotationEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { QuotationRepository } from "./QuotationRepo";

export const QuotationRepoImpl = (): QuotationRepository => {
    const url = '/v1/quotation';

    const getEntities = async (): Promise<QuotationEntity[]> => {
        return axiosGetData(referenceAxiosInstance, url, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (entity: QuotationEntity): Promise<ResponseEntity> => {
        return await axiosPostData(referenceAxiosInstance, `${url}`, entity);
    }


    return {
        onSave: onSave,
        getEntities: getEntities
    }
}